var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.93879 7.14922C7.36212 5.54199 7.57328 4.74842 6.01471 2.62888C4.54663 0.569616 3.50088 -1.23852 1.70098 1.10201C0.373681 2.78961 -0.13914 3.00056 0.0318004 4.73838C0.715561 10.3536 10.248 19.6555 15.6779 20.0071C17.3973 20.0674 17.5381 19.5149 19.0564 17.998C21.1681 16.0292 19.3581 15.095 17.3269 13.6284C15.165 12.1919 14.3908 12.4732 13.0836 15.0448C11.3239 15.6575 4.50641 8.97745 4.93879 7.14922Z","fill":"#222222"}));
}

IconPhone.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
